'use strict';
import { Infoblock } from './infoblock.js';

export class InfoblockServices extends Infoblock {
	
	constructor(component_id) {
		super(component_id);
		
		const backendData = yalwa.v.components[this.id].data;
		
		this.vue_data_vars = {
			maxAllowed: backendData.maxAllowed || 6,
			services: [],
			servicesFromBE: structuredClone(backendData.services || []),
			loading: false,
			servicesCategories: backendData.service_categories,
			titleLimit: backendData.titleLimit,
			descLimit: backendData.descLimit
		};
		
		this.vue_method_vars = {
			
			initialize() {
				this.buildInitialState();
			},
			
			// -------------------------
			// BUILD STATE
			// -------------------------
			buildInitialState() {
				
				const persisted = this.servicesFromBE.map(item => ({
					serviceID: item.serviceID || null,
					title: item.title || '',
					description: item.description || '',
					price: item.price || '',
					category: item.category || 1,
					isPersisted: true,
					_deleted: false
				}));
				
				const emptySlots = Array.from(
					{ length: this.maxAllowed - persisted.length },
					() => this.emptyRow()
				);
				
				this.services = [...persisted, ...emptySlots];
			},
			
			emptyRow() {
				return {
					serviceID: null,
					title: '',
					description: '',
					price: '',
					category: 1,
					isPersisted: false,
					_deleted: false
				};
			},
			
			// -------------------------
			// DELETE (LOCAL ONLY)
			// -------------------------
			clearService(index) {
				const service = this.services[index];
				
				if (service.serviceID) {
					service.title = '';
					service.description = '';
					service.category = 1;
					service.price = '';
					service._deleted = true;
				} else {
					this.services[index] = this.emptyRow();
				}
			},
			
			// -------------------------
			// SAVE (ONLY API CALL)
			// -------------------------
			saveIconBoxData() {
				this.is_saving = true;
				
				const cleaned = this.services.map(item => {
					
					// DELETE
					if (item._deleted && item.serviceID) {
						return {
							serviceID: item.serviceID,
							deleted: true
						};
					}
					
					const title = item.title?.trim() || '';
					const description = item.description?.trim() || '';
					
					// skip empty
					if (!title && !description) return null;
					
					return {
						serviceID: item.serviceID,
						title,
						description,
						price: Math.max(0, item.price || 0),
						category: item.category
					};
					
				}).filter(Boolean);
				
				yalwa.basics.ajaxservice({
					type: 'POST',
					resource: 'profileupdate',
					action: 'update_services',
					data: {
						data: JSON.stringify(cleaned)
					},
					include_session: true
				}).then(response => {
					
					if (response.type === 'success') {
						if (response.vip_completion) {
							document.dispatchEvent(new CustomEvent('vip_guide_state', {detail: response.vip_completion}));
						}
						this.servicesFromBE = structuredClone(response.services || []);
						this.buildInitialState();
						this.close();
					}
					
					yalwa.basics.toast({
						message: response.label,
						type: response.type
					});
					
				}).finally(() => {
					this.is_saving = false;
				});
			},
			
			// -------------------------
			// CLOSE (RESET)
			// -------------------------
			close() {
				this.buildInitialState();
				this.closeDialog();
			}
		};
		
		this.extras = {
			computed: {
				
				// -------------------------
				// SAVE BUTTON CONTROL
				// -------------------------
				isUnchanged() {
					
					const normalize = list =>
						(Array.isArray(list) ? list : [])
							.map(item => ({
								id: item.serviceID || null,
								title: (item.title || '').trim(),
								desc: (item.description || '').trim(),
								price: item.price ? String(item.price) : '',
								category: item.category || 0,
								deleted: item._deleted || false
							}))
							.filter(item =>
								item.title !== '' ||
								item.desc !== '' ||
								item.price !== '' ||
								item.deleted
							)
							.sort((a, b) => (a.id || 0) - (b.id || 0));
					
					const current = normalize(this.services);
					const backend = normalize(this.servicesFromBE);
					
					return JSON.stringify(current) !== JSON.stringify(backend);
				}
			},
			watch : {
			
			},
			mounted() {
				this.initialize();
			}
		};
	}
	
	setup_vars(Vue) {}
}